import { useIonModal } from '@ionic/react'

import { ButtonRoundArrow } from '@apps-common/components/elements/button'
import { UnitActivationsFilterModal } from '@apps-common/components/modals/UnitActivationsFilterModal'
import { commonIcons } from '@apps-common/config/icons'
import { MODAL_NO_BLUR } from '@apps-common/config/modal'
import { useFilterModalAnimation } from '@apps-common/hooks/useFilterModalAnimation'

export const UnitActivationFilterButton: React.FC = () => {
  const animations = useFilterModalAnimation({ desktopCss: MODAL_NO_BLUR.cssClass })

  const [present, dismiss] = useIonModal(UnitActivationsFilterModal, {
    componentProps: {},
    onDismiss: (data: string, role: string) => {
      dismiss(data, role)
    },
    enableBackdropDismiss: true
  })

  return (
    <ButtonRoundArrow
      classes='bg-brand'
      iconClasses='text-on-brand'
      Icon={commonIcons.filter}
      callback={() =>
        present({
          cssClass: animations.css,
          ...animations
        })
      }
      tooltip={{
        id: `unit-activation-filter-tooltip`,
        message: 'Filter'
      }}
    />
  )
}
